import useInputTypesHook from "hooks/useInputTypes";
const useInputTypes = () => {
  const { data } = useInputTypesHook();
  return data == null ? void 0 : data.types;
};
export default useInputTypes;
